import React, { useCallback } from 'react';
import { useDispatch, useSelector } from '@shared/store';
import { MBActionButtonsComponent } from '../components/message/bubble/components/actionButtons';
import * as Actions from '../store/actions';

interface OwnProps {
  message: MBAPI.ChatMessage;
  channelSlug: string;
  isHovering: boolean;
  includeEdit?: boolean;
}

export function MBActionButtons({
  message,
  channelSlug,
  isHovering,
  includeEdit = true,
}: OwnProps) {
  const dispatch = useDispatch();
  const currentUserId = useSelector(state => state.appState.currentUserId);
  const deliveryStatus = useSelector(
    state => state.chatMessages.deliveryStatusFromMessageUuid[message.meta.uuid ?? ''],
  );
  const isMyMessage = message.sender.id === currentUserId;
  const isSent = !deliveryStatus || deliveryStatus === 'sent';
  const onEdit = useCallback(
    () => Actions.startEditingMessage(message, channelSlug)(dispatch),
    [message, channelSlug, dispatch],
  );
  const onDelete = useCallback(
    () => Actions.deleteMessage(message, channelSlug)(dispatch),
    [message, channelSlug, dispatch],
  );

  return (
    <MBActionButtonsComponent
      message={message}
      channelSlug={channelSlug}
      isHovering={isHovering}
      isMyMessage={isMyMessage}
      onDelete={onDelete}
      onEdit={onEdit}
      includeEdit={includeEdit}
      isSent={isSent}
    />
  );
}
